export var COLORS=["WHITE","YELLOW","GREEN","CYAN","BLUE","MAGENTA","RED","BLACK"];